import { MainLayout } from 'components/Layout';
import React, { useEffect } from 'react';

export const TermsOfUse = () => {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <MainLayout title="Terms of Use" description="Terms of Use for Justknow">
      <div className="px-4 py-6 max-w-screen-md mx-auto">
        <h1 className="text-3xl font-semibold mb-4">Terms of Use</h1>
        <p className="text-sm text-gray-600 mb-6">Last updated: 22nd April, 2026</p>

        <p className="mb-4">
          Welcome to Justknow. These Terms govern your use of the platform. By using Justknow, you
          agree to these Terms, including our strict policies on user safety, content, and conduct.
        </p>

        {/* Eligibility */}
        <h2 className="text-2xl font-semibold mt-6 mb-2">1. Eligibility</h2>
        <p className="mb-4">
          You must be at least 18 years old to use Justknow. By registering, you confirm that your
          information is accurate and that you meet this requirement.
        </p>

        {/* Account */}
        <h2 className="text-2xl font-semibold mt-6 mb-2">2. Account Responsibility</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>You are responsible for your account and all activities under it.</li>
          <li>You must provide accurate and identifiable profile information.</li>
          <li>Impersonation or anonymous misuse of the platform is prohibited.</li>
        </ul>

        {/* License */}
        <h2 className="text-2xl font-semibold mt-6 mb-2">3. License Grant</h2>
        <p className="mb-4">
          Justknow grants you a limited, non-transferable, revocable license to use the app for
          personal, non-commercial purposes.
        </p>

        {/* Restrictions */}
        <h2 className="text-2xl font-semibold mt-6 mb-2">4. Restrictions</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>Do not reverse engineer or copy the app</li>
          <li>Do not misuse the platform for illegal or harmful activities</li>
          <li>Do not attempt to bypass safety or moderation systems</li>
        </ul>

        {/* Chat Safety */}
        <h2 className="text-2xl font-semibold mt-6 mb-2">5. Chat and Connection Safety</h2>
        <p className="mb-4">
          Justknow does not support anonymous or unverified random chat connections. Before any
          interaction begins, users are provided with identifiable information about the other
          participant and must explicitly choose to accept, decline, or skip the connection.
        </p>

        {/* Zero Tolerance */}
        <h2 className="text-2xl font-semibold mt-6 mb-2">6. Zero Tolerance Policy</h2>
        <p className="mb-4">
          Justknow maintains a strict zero-tolerance policy for objectionable content and abusive
          behavior. This includes, but is not limited to:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>Harassment, threats, or bullying</li>
          <li>Hate speech or discrimination</li>
          <li>Sexual or explicit content</li>
          <li>Fraud, scams, or misleading behavior</li>
        </ul>

        {/* Moderation */}
        <h2 className="text-2xl font-semibold mt-6 mb-2">7. Content Moderation and Enforcement</h2>
        <p className="mb-4">
          We actively monitor and enforce platform safety through automated systems and manual
          review. Any reported objectionable content will be reviewed and acted upon within 24
          hours.
        </p>
        <p className="mb-4">
          Violating users may have their content removed and accounts suspended or permanently
          banned.
        </p>

        {/* Reporting */}
        <h2 className="text-2xl font-semibold mt-6 mb-2">8. Reporting and Blocking</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>Users can report objectionable content directly within the app</li>
          <li>Users can block other users at any time</li>
          <li>Blocked users cannot interact with you on the platform</li>
        </ul>

        {/* Services */}
        <h2 className="text-2xl font-semibold mt-6 mb-2">9. Services</h2>
        <p className="mb-4">
          Justknow provides location-based services including social interaction, local discovery,
          and user-coordinated services such as rides and deliveries.
        </p>

        {/* Location */}
        <h2 className="text-2xl font-semibold mt-6 mb-2">10. Location Usage</h2>
        <p className="mb-4">
          The platform relies on location data to function. Disabling location access may limit
          functionality.
        </p>

        {/* Apple */}
        <h2 className="text-2xl font-semibold mt-6 mb-2">11. Apple App Store Terms</h2>
        <p className="mb-4">
          This agreement is between you and Justknow, not Apple Inc. Apple is not responsible for
          the app and provides no support or warranty obligations.
        </p>

        {/* Termination */}
        <h2 className="text-2xl font-semibold mt-6 mb-2">12. Termination</h2>
        <p className="mb-4">
          We may suspend or terminate accounts that violate these Terms or compromise user safety.
        </p>

        {/* Liability */}
        <h2 className="text-2xl font-semibold mt-6 mb-2">13. Limitation of Liability</h2>
        <p className="mb-4">
          The app is provided "as is" without warranties. We are not liable for damages arising from
          platform use or user interactions.
        </p>

        {/* Law */}
        <h2 className="text-2xl font-semibold mt-6 mb-2">14. Governing Law</h2>
        <p className="mb-4">These Terms are governed by the laws of Uganda.</p>

        {/* Updates */}
        <h2 className="text-2xl font-semibold mt-6 mb-2">15. Changes to Terms</h2>
        <p className="mb-4">
          Continued use of the platform after updates means you accept the revised Terms.
        </p>

        {/* Contact */}
        <h2 className="text-2xl font-semibold mt-6 mb-2">Contact Us</h2>
        <p className="mb-4">jonahgeek@gmail.com</p>
      </div>
    </MainLayout>
  );
};
